/* eslint-disable max-len */
import React from "react";
import Heading from "components/Common/Heading/Heading";
import PageBanner from "components/Common/PageBanner/PageBanner";
import "./Homepage.scss";
import { Divider } from "antd";
import MyCollection from "../Product/MyCollection";
import ProductListing from "components/Product/ProductListing";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "hooks/reduxHooks";

const Homepage = () => {
  const userString = localStorage.getItem("UserRecord");
  const userRecord = userString ? JSON.parse(userString) : null;
  const artifConfigurations = useAppSelector(
    (state) => state.productCustomization.artifConfigurations
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reload = searchParams.get("reload");
  if (reload) {
    navigate("/");
  }

  return (
    <div className="homepage-wrapper">
      <PageBanner />
      <div className="page-content-wrapper">
        <Heading titleText="Create a new configuration" titleClass="configuration-heading mb-3" />
        <ProductListing artifConfigurations={artifConfigurations} />
        {userRecord ? (
          <>
            <Divider />
            <MyCollection artifConfigurations={artifConfigurations} />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Homepage;
